import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Chart, Line, Scale, Tooltip,
} from 'ant-design-mobile-chart';
import dayjs from 'dayjs';

class MeasurementChart extends Component {
  constructor(...args) {
    super(...args);
    this.handleToolTipChange = this.handleToolTipChange.bind(this);
  }

  handleToolTipChange(ev) {
    const item = ev.items[0];
    const { title } = this.props;
    const { timestamp } = item.origin;
    item.title = dayjs(timestamp).format('YY-MM-DD HH:mm:ss');
    item.name = title;
  }

  render() {
    const { data, timeSpan } = this.props;
    const source = data.map(item => ({
      timestamp: item[0],
      value: item[1],
    }));
    const mask = (timeSpan === 'current' || timeSpan === 'day') ? 'HH:mm' : 'MM-DD';
    const width = window.innerWidth;
    return (
      <Chart source={source} width={width} height="200" pixelRatio={window.devicePixelRatio}>
        <Line position="timestamp*value" shape="smooth" style={{ fillOpacity: 0.7 }} />
        <Scale field="timestamp" range={[0, 1]} type="timeCat" mask={mask} />
        <Scale field="value" />
        <Tooltip offsetY={16} showTitle showCrosshairs onChange={this.handleToolTipChange} />
      </Chart>
    );
  }
}

MeasurementChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.number).isRequired,
  ).isRequired,
  timeSpan: PropTypes.oneOf(['current', 'day', 'week', 'month', 'quarter']).isRequired, // xu_mod
  title: PropTypes.string.isRequired,
};

export default MeasurementChart;
